import styled, { keyframes } from 'styled-components';
import { THEME } from '@/common/styles/theme';

export const fadeIn = keyframes`
  from { opacity: 0; transform: translateY(10px); }
  to { opacity: 1; transform: translateY(0); }
`;

export const Overlay = styled.div`
	position: fixed;
	inset: 0;
	z-index: 5000;
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 24px;
	background: rgba(3, 1, 5, 0.42);
	backdrop-filter: blur(24px) saturate(1.1);
`;

export const Modal = styled.article`
	position: relative;
	width: min(560px, calc(100vw - 40px));
	border: 1px solid rgba(255, 255, 255, 0.1);
	border-radius: 20px;
	padding: 40px 36px 34px;
	background:
		radial-gradient(circle at 24% 0%, rgba(255, 77, 242, 0.18), transparent 36%),
		linear-gradient(135deg, rgba(255, 255, 255, 0.09), rgba(255, 255, 255, 0.025)),
		rgba(19, 7, 23, 0.76);
	box-shadow: 0 28px 90px rgba(0, 0, 0, 0.62), 0 0 34px rgba(255, 77, 242, 0.14);
	backdrop-filter: blur(34px) saturate(1.14);
	animation: ${fadeIn} 0.3s ease-out;
	color: ${THEME.text};
`;

export const CloseButton = styled.button`
	position: absolute;
	top: 14px;
	right: 14px;
	width: 38px;
	height: 38px;
	border: 1px solid rgba(255, 255, 255, 0.08);
	border-radius: 50%;
	color: rgba(255, 255, 255, 0.8);
	background: rgba(255, 255, 255, 0.06);
	font-size: 1.25rem;
	line-height: 1;
	cursor: pointer;
	display: grid;
	place-items: center;
`;

export const ModalTitle = styled.h2`
	margin: 0 36px 24px 0;
	font-family: ${THEME.fontDisplay};
	font-size: clamp(1.55rem, 3vw, 2rem);
	line-height: 1.05;
	font-weight: 700;
`;

export const Textarea = styled.textarea`
	width: 100%;
	min-height: 150px;
	resize: vertical;
	border: 1px solid rgba(255, 255, 255, 0.08);
	border-radius: 12px;
	outline: 0;
	padding: 17px;
	color: ${THEME.text};
	font-size: 0.94rem;
	background: rgba(3, 1, 5, 0.72);

	&::placeholder {
		color: rgba(216, 189, 228, 0.62);
	}
`;

export const Actions = styled.div`
	display: grid;
	grid-template-columns: 1fr 1fr;
	gap: 14px;
	margin-top: 22px;
`;

export const SecondaryButton = styled.button`
	min-height: 48px;
	border-radius: 10px;
	border: 1px solid rgba(255, 255, 255, 0.12);
	color: ${THEME.text};
	font-weight: 800;
	background: rgba(255, 255, 255, 0.035);
	cursor: pointer;

	&:disabled {
		opacity: 0.45;
		cursor: not-allowed;
	}
`;

export const PrimaryButton = styled.button`
	min-height: 48px;
	border-radius: 10px;
	border: 1px solid rgba(255, 214, 255, 0.22);
	color: ${THEME.text};
	font-weight: 800;
	background: linear-gradient(135deg, rgba(176, 38, 255, 0.82), rgba(255, 77, 242, 0.68));
	cursor: pointer;

	&:disabled {
		opacity: 0.45;
		cursor: not-allowed;
	}
`;

export const HintMessage = styled.p`
	margin: 12px 4px 0;
	color: rgba(226, 200, 236, 0.74);
	text-align: center;
	line-height: 1.45;
	font-size: 0.88rem;
`;

export const DisabledMessage = styled.p`
	color: rgba(216, 189, 228, 0.72);
	font-size: 0.82rem;
	margin-top: 10px;
	text-align: center;
`;
